/*
  Most color names haven't been changed to keep backwards compatibility.

  However we should gradually shift to the coloring system that tailwind recommends.
  This means:

  - The "color" prefix should be removed from all color names
  - Colors names should be primitive ex. 'blue' should be used instead of 'primary'
  - Shades should be numbered the following way: 500 should be the main color, 400 should be a shade darker, 600 should be a shade lighter, etc.
  - When constructing colors with let's say 3 shades, you should distribute them evenly to leave room for more shades in the future. ex.(blue, 3 shades: blue-200, blue-500, blue-800)

  You can use this page to organize color shades: https://elektrobild.org/tools/sort-colors
*/
// WARNING: changing colors here will need a rebuild to work everywhere in the app.
export const colors = {
  transparent: 'transparent',
  'color-white': '#FFFFFF',
  'color-black': '#000000',
  straw: '#D7CA78',
  'dark-vanilla': '#C5C09C',
  'tinted-grey': '#B5BFC0',
  'navy-100': '#F6F8FF',
  'navy-200': '#EDF2FF',
  'navy-300': '#E2E7F5',
  'navy-400': '#CBD7F7',
  'navy-500': '#A5B4DE',
  'navy-600': '#667DBC',
  'navy-700': '#2C427E',
  'navy-900': '#07143D', // used to be primary '#071743'
  'red-200': '#f9A6A6',
  'red-300': '#FF8A8A',
  'red-400': '#FF6767',
  'red-500': '#EB5757',
  'red-600': '#F14B43',
  'green-100': '#EFF9F3',
  'green-150': '#D5F4E2',
  'green-400': '#2ECC71',
  'green-600': '#27AE60',

  'yellow-100': '#FFF8ED',
  'yellow-400': '#FFDEA8',
  'yellow-450': '#FFCC79',
  'yellow-500': '#ffba49',
  'blue-500': '#5998E7',
  'blue-600': '#3498DB',
  'blue-700': '#4392F1',

  'grey-100': '#FDFDFD',
  'grey-150': '#FCFCFC',
  'grey-200': '#F3F3F3',
  'grey-300': '#EDEDED',
  'grey-400': '#BBBBBB',
  'grey-500': '#9D9D9D',
  'grey-600': '#747474',
  'grey-900': '#171717',

  'purple-300': '#C0AED6',
  'purple-600': '#9B51E0',
  'purple-700': '#8E44AD',
};
